import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-flexbox-grid'

import { ContentBlock } from 'components/ContentBlock'
import { Form, Text, Select } from 'components/forms'
import { notEmpty } from 'helpers/validators'
import Button from 'components/Button'
import Divider from 'components/Divider'
import globalStyles from 'style/app.module.scss'

const SalesGroup = ({ data = {}, formData, mutations: { updateItem, createItem }, newRecord }) => {
	const [t] = useTranslation()

	return(
		<Form
			initialValues={formData}
			onSubmit={newRecord ? createItem : updateItem}
			smartSubmit={!newRecord}
			className={globalStyles['flex-cols']}
		>
			{({ formState: { values } }) => (
				<Fragment>
					<ContentBlock alwaysExpanded>
						<Row>
							<Col xs className='narrow-col'>
								<Text
									field='code'
									label={t('common.fields.code')}
									{...notEmpty()}
									validateOnChange
									shrink
								/>
							</Col>
							<Col xs>
								<Text
									field='name'
									label={t('common.fields.name')}
									{...notEmpty()}
									validateOnChange
								/>
							</Col>
							<Col xs>
								<Select
									field='groupId'
									label={t('common.strings.group')}
									{...notEmpty()}
									validateOnChange
									options={[
										{ label: `${t('common.strings.group')} 1`, value: '1' },
										{ label: `${t('common.strings.group')} 2`, value: '2' },
										{ label: `${t('common.strings.group')} 3`, value: '3' }
									]}
								/>
							</Col>
						</Row>
						{newRecord &&
							<Fragment>
								<Divider />
								<div>
									<Button
										type='submit'
										status={(values.acountNum || values.name) ? 'primary' : 'inactive'}
										text={t('common.buttons.create')}
									/>
								</div>
							</Fragment>
						}
					</ContentBlock>
				</Fragment>
			)}
		</Form>
	)
}

export default SalesGroup
